// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1zquW","errorLogs":"styles_errorLogs__3C05M"};